type HomeSectionHeadingProps = {
  title: string;
  subtitle: string;
};

export const HomeSectionHeading = ({
  title,
  subtitle,
}: HomeSectionHeadingProps) => (
  <div className='row use-gap mb-50'>
    <div className='col-lg-12 align-items-center gap-3'>
      <h6 className='section-subtitle section-subtitle-2 ltn__secondary-color'>
        {subtitle}
      </h6>
      <h1 className='section-title'>{title}</h1>
    </div>
  </div>
);
